import {useAppSelector} from '@/hooks';
import {selectIsSinglePageLayout} from '@Components/poster-editor/poster-editor-reducer';

/**
 * True when the whiteboard is in single-page (zoomed) mode rather than scrolling pages.
 * Mobile is always in this mode; on desktop it matches the timeline toggle.
 */
export const useIsSinglePageLayout = (): boolean => {
  return useAppSelector(selectIsSinglePageLayout);
};
